// @ts-strict-ignore
import React from 'react'
import { MenuItem } from '@mui/material'
import FocusFadeGroup from 'components/FocusFadeGroup'
import SelectField from 'components/SelectField'
import { FormValueInput, FormValueMeta } from 'types'
import { useLazyLoadQuery } from 'react-relay'
import { graphql } from 'relay-runtime'
import { JobPostingManagerField_Query } from '__generated__/JobPostingManagerField_Query.graphql'

interface IJobPostingManagerField {
  input: FormValueInput<number>
  meta: FormValueMeta
  editable?: boolean
}

const JobPostingManagerField = (props: IJobPostingManagerField) => {
  const { input, meta, editable } = props
  // TODO: update query to only load managers and permission data for relevant firm and not all firms
  const data = useLazyLoadQuery<JobPostingManagerField_Query>(graphql`
    query JobPostingManagerField_Query($editable: Boolean!) {
      currentUser @include(if: $editable) {
        managerContract {
          isFirmAdmin
        }
        firms {
          contracts(filters: { allowHireJobsAccess: true, statuses: [active, paused] }, first: 1000) {
            edges {
              node {
                freelancer {
                  rawId
                  name
                }
              }
            }
          }
        }
      }
    }
  `, {
    editable: editable || false,
  }, {
    fetchPolicy: 'store-and-network',
  })
  const allowed = Boolean(data?.currentUser?.managerContract?.isFirmAdmin)
  const editableManagers = data?.currentUser?.firms?.[0]?.contracts?.edges?.map(edge => edge?.node?.freelancer) || []

  if (!editable) {
    return null
  }

  return (
    <FocusFadeGroup focused={false}>
      <SelectField
        input={input}
        meta={meta}
        label="Owner"
        helperText={allowed ? 'Note: this setting will not be displayed on your job posting.' : 'Only company admins can change this setting.'}
        disabled={!allowed}
      >
        {editableManagers.map(manager => (
          <MenuItem key={manager.rawId} value={manager.rawId}>
            {manager.name}
          </MenuItem>
        ))}
      </SelectField>
    </FocusFadeGroup>
  )
}

export default JobPostingManagerField
